export const levels = [
  {
    key: 'levelsix',
    value: '6단계'
  },
  {
    key: 'levelfive',
    value: '5단계'
  },
  {
    key: 'levelfour',
    value: '4단계'
  },
  {
    key: 'levelthree',
    value: '3단계'
  },
  {
    key: 'leveltwo',
    value: '2단계'
  },
  {
    key: 'levelone',
    value: '1단계'
  }
];
export const severityTP = [
  {
    key: 'frontserious',
    value: '심각'
  },
  {
    key: 'frontseverity',
    value: '중증도'
  },
  {
    key: 'frontlight',
    value: '경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'backlight',
    value: '경미'
  },
  {
    key: 'backseverity',
    value: '중증도'
  },
  {
    key: 'backserious',
    value: '심각'
  }
];

export const severityNSP = [
  {
    key: 'leftserious',
    value: '심각'
  },
  {
    key: 'leftseverity',
    value: '중증도'
  },
  {
    key: 'leftlight',
    value: '경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'rightlight',
    value: '경미'
  },
  {
    key: 'rightseverity',
    value: '중증도'
  },
  {
    key: 'rightserious',
    value: '심각'
  }
];

export const severityK = [
  {
    key: 'flexionserious',
    value: '심각'
  },
  {
    key: 'flexionseverity',
    value: '중증도'
  },
  {
    key: 'flexionlight',
    value: '경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'extensionlight',
    value: '경미'
  },
  {
    key: 'extensionseverity',
    value: '중증도'
  },
  {
    key: 'extensionserious',
    value: '심각'
  }
];

export const severityOX = [
  {
    key: 'varus',
    value: '내반슬'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'valgus',
    value: '외반슬'
  }
];

export const severityLR = [
  {
    key: 'pserious',
    value: '심각'
  },
  {
    key: 'pseverity',
    value: '중증도'
  },
  {
    key: 'plight',
    value: '경미'
  },
  {
    key: 'normal',
    value: '정상'
  },
  {
    key: 'slight',
    value: '경미'
  },
  {
    key: 'sseverity',
    value: '중증도'
  },
  {
    key: 'sserious',
    value: '심각'
  }
];

export const postureData = [
  {
    key: 'turtleneck',
    value: '거북목',
    severity: severityTP
  },
  {
    key: 'neckside',
    value: '목측굴',
    severity: severityNSP
  },
  {
    key: 'shoulderbalance',
    value: '어깨균형',
    severity: severityNSP
  },
  {
    key: 'pelvisbalance',
    value: '골반균형',
    severity: severityNSP
  },
  {
    key: 'pelvictilt',
    value: '골반경사',
    severity: severityTP
  },
  {
    key: 'kneeflexion',
    value: '무릎굴곡',
    severity: severityK
  },
  {
    key: 'oxleftleg',
    value: '좌',
    severity: severityOX
  },
  {
    key: 'oxrightleg',
    value: '우',
    severity: severityOX
  },

  {
    key: 'leftfoot',
    value: '좌',
    severity: severityLR
  },
  {
    key: 'rightfoot',
    value: '우',
    severity: severityLR
  },
  {
    key: 'musculoskeletalLevel',
    value: '근골격지수',
    severity: levels
  }
];
